// extracted by mini-css-extract-plugin
export var fastFact = "fast-fact-module--fast-fact--afb65";
export var fastFact__content = "fast-fact-module--fast-fact__content--2931e";
export var fastFact__content__caption = "fast-fact-module--fast-fact__content__caption--14998";
export var fastFact__content__copy = "fast-fact-module--fast-fact__content__copy--76e41";
export var fastFact__content__eyebrow = "fast-fact-module--fast-fact__content__eyebrow--66088";
export var fastFact__content__headline = "fast-fact-module--fast-fact__content__headline--fc0e3";
export var fastFact__content__logo = "fast-fact-module--fast-fact__content__logo--76ceb";
export var fastFact__content__logoWrapper = "fast-fact-module--fast-fact__content__logo-wrapper--638cb";
export var fastFact__content__trailing = "fast-fact-module--fast-fact__content__trailing--be563";
export var fastFact__img = "fast-fact-module--fast-fact__img--b7c11";
export var fastFact__imgWrapper = "fast-fact-module--fast-fact__img-wrapper--9a2b4";
export var mt0 = "fast-fact-module--mt-0--8760d";
export var mt1 = "fast-fact-module--mt-1--71739";
export var mt2 = "fast-fact-module--mt-2--32ff6";
export var mt3 = "fast-fact-module--mt-3--d2eab";
export var mt4 = "fast-fact-module--mt-4--f68a5";
export var mt5 = "fast-fact-module--mt-5--e3218";
export var mt6 = "fast-fact-module--mt-6--f4cc5";